const genKey = () => {
  return `${Date.now()}_${Math.random().toString(36).substr(0, 6)}`
}
export default {
  created () {
    this._intervals = {}
  },
  methods: {
    $setInterval (cb, ms, key = genKey()) {
      if (this._intervals[key]) {
        console.warn(`[interval] key为${key}的定时器已存在`)
        return
      }
      const interval = setInterval(cb, ms)
      this._intervals[key] = interval
    },
    $clearInterval (key = Object.keys(this._intervals)) {
      const keys = Array.isArray(key) ? key : [key]
      keys.forEach(key => {
        const interval = this._intervals[key]
        if (interval) {
          this._intervals[key] = undefined
          clearInterval(interval)
        }
      })
    }
  },
  beforeDestroy () {
    this.$clearInterval()
    this._intervals = null
  }
}



// WEBPACK FOOTER //
// ./src/mixin/interval.js